import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Notification } from '../shared/models/notification.model';
import { CountAndResults, NotificationSearch } from '../shared/types';

@Injectable()
export class NotificationService {
  private http = inject(HttpClient);


  add(notification: Notification): Observable<void> {
    return this.http.post<void>('/api/notification', notification);
  }

  search(body: NotificationSearch): Observable<CountAndResults> {
    return this.http.post<CountAndResults>('/api/notifications/search', body);
  }

  update(notification: Notification): Observable<void> {
    return this.http.put<void>(`/api/notification/${notification._id}`, notification);
  }

  markAllAsRead(): Observable<void> {
    return this.http.put<void>('/api/notifications/markallasread', {});
  }

}
